export default {
  title: 'The Parlay Template',
  icon: '/static/templates_icons/TheParlayTemplate.svg',
  prompt: `
    <h3>Learning Goals</h3>
    <p>
      List the ideas, topics or essential questions students will be exploring in this discussion.
      Are there any specific skills or curriculum expectations we want to practice?
    </p>
    <h3>Content & Multimedia</h3>
    <p>
      Insert external links to articles, images, videos, or reference existing class materials for students to review before submitting their response.
    </p>
    <h3>Discussion Questions</h3>
    <p>
      Provide students with the specific question(s) to address in their response.
      <br><br>
      <span>
        &nbsp;&nbsp; 1. [Question 1] <br>
        &nbsp;&nbsp; 2. [Question 2] <br>
      </span>
    </p>
    <h3>Peer Feedback Instructions</h3>
    <p>
      Provide instructions for students to comment on other responses during the discussion.
      Don’t forget that you can update the guided feedback questions in the settings above.
    </p>
  `,
};



// WEBPACK FOOTER //
// ./src/app/components/textEditor/templates/theParlayTemplate.js